export enum SearchFlightSelectionType {
  from = 'from',
  to = 'to',
}
